import { useEffect, useRef } from 'react';
import { setFloatingTimer, clearFloatingTimer, requestTimerAlerts, setFloatingControls } from './floatingTimer';

/**
 * Mirror a timer into the floating mini-timer while `active`.
 * countdown: { mode:'countdown', label, remainingMs, totalMs, paused }
 * stopwatch: { mode:'stopwatch', label, elapsedMs, paused }
 * Optional onPause / onResume / onSkip / onAddTime (+15s) show as buttons in the floating window.
 */
export const useFloatingTimer = (active, t) => {
  const owner = useRef(Symbol('timer')).current;
  const ctl = useRef(t);
  ctl.current = t;
  const has = `${!!t.onPause}${!!t.onResume}${!!t.onSkip}${!!t.onAddTime}`;
  const key = active ? `${t.mode}|${t.label}|${Math.round((t.remainingMs ?? t.elapsedMs ?? 0) / 1000)}|${t.totalMs}|${t.paused}|${t.alert}` : 'off';
  useEffect(() => {
    if (!active) return;
    requestTimerAlerts();
    const now = Date.now();
    setFloatingTimer(t.mode === 'stopwatch'
      ? { mode: 'stopwatch', label: t.label, startAt: now, baseMs: t.elapsedMs, paused: t.paused, pausedMs: t.elapsedMs }
      : { mode: 'countdown', label: t.label, endAt: now + t.remainingMs, totalMs: t.totalMs, paused: t.paused, pausedMs: t.remainingMs, alert: t.alert }, owner);
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!active) return;
    const c = ctl.current;
    setFloatingControls({
      onPause: c.onPause && (() => ctl.current.onPause?.()),
      onResume: c.onResume && (() => ctl.current.onResume?.()),
      onSkip: c.onSkip && (() => ctl.current.onSkip?.()),
      onAddTime: c.onAddTime && (() => ctl.current.onAddTime?.()),
    }, owner);
  }, [active, has]);
  useEffect(() => (active ? () => clearFloatingTimer(owner) : undefined), [active]);
};

export default useFloatingTimer;
